import { render, staticRenderFns } from "./DehorningDisbudding1.vue?vue&type=template&id=6e908c3c&scoped=true&"
import script from "./DehorningDisbudding1.vue?vue&type=script&lang=js&"
export * from "./DehorningDisbudding1.vue?vue&type=script&lang=js&"
import style0 from "./DehorningDisbudding1.vue?vue&type=style&index=0&id=6e908c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e908c3c",
  null
  
)

export default component.exports